export default __webpack_public_path__ + "../staticImages/sprite-elbphilharmonie-2x.png";